import { render, staticRenderFns } from "./expenseView.vue?vue&type=template&id=4678ba1f&scoped=true"
import script from "./expenseView.vue?vue&type=script&lang=js"
export * from "./expenseView.vue?vue&type=script&lang=js"
import style0 from "./expenseView.vue?vue&type=style&index=0&id=4678ba1f&prod&lang=scss&scoped=true"
import style1 from "./expenseView.vue?vue&type=style&index=1&id=4678ba1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4678ba1f",
  null
  
)

export default component.exports